import {
  menuPage,
  modulePage
} from '../config/menuPage'
import {
  addressJson
} from '../config/address'
const debug = process.env.NODE_ENV !== 'production'

const isMock = false

const page = {
  pageSize: 10,
  pageSizeOptions: ['10', '20', '30', '40', '50'],
  total: 0,
  showTotal: '',
  showSizeChanger: true,
  defaultCurrent: 1,
  current: 1
}
const pageFilter = {
  sorting: '',
  skipCount: 0,
  maxResultCount: 10
}
const base = {
  mock: '',
  url:"https://bapi.haofengjing.com/",
  //url:   "http://119.3.85.163:8011",
  //url:"http://localhost:21421",
  fileUrl: 'https://bimg.haofengjing.com/api/upload'//'http://119.3.85.163:8010/api/upload' // 'http://119.3.85.163:8010/api/upload'
}

const pages = menuPage

const config = {
  isMock,
  debug,
  page,
  base,
  pages,
  modulePage: modulePage,
  pageFilter: pageFilter,
  addressJson
}

export default config



// WEBPACK FOOTER //
// ./src/config/index.js